import axios from "axios";
import { apiConstants } from "./constants";
import { attachQrSession, shouldRedirectToInvalidQr } from "./qrAuthorization";
import { pageConstants } from './constants';

axios.defaults.headers.common = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

axios.defaults.baseURL = apiConstants.baseURL;

axios.interceptors.request.use(
  function (config) {
    // const storage = JSON.parse(localStorage.getItem("persist:root"));
    // let auth_token;

    // if (storage) {
    //   auth_token = JSON.parse(storage.auth).user?.mb_token;
    // }
    // config.headers["Authorization"] = "Bearer " + auth_token;
    // config.headers["pathname"] = window.location.pathname;

    return attachQrSession(config);
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code range of 2xx
    return response.data;
}, error => {
    // Any status code that lie outside the range of 2xx
    if (shouldRedirectToInvalidQr(error)) {
        const redirectPath = `${pageConstants.subFolder}/invalid_qr`;
        window.location.href = redirectPath;
    }
    return Promise.reject(error);
});

export default axios;
